import { setupAnalytics } from "./analytics/default";
import { logout } from "./analytics/events/logout";

const analytics = setupAnalytics();

export const logoutHandler = () => {
    // desktop and mobile logout buttons
    const logoutButtons = document.querySelectorAll('.btn-logout');
    
    if (logoutButtons.length < 1) {
        return;
    }

    logoutButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
    
            if (inProgress(button)) {
                return;
            }
    
            setInProgress(button);
    
            const logoutUrl = button.href;
        
            if (logoutUrl == null || logoutUrl === '') {
                return;
            }
    
            analytics.trackEvent(logout());
            analytics.resetIdentity();
    
            window.location.assign(logoutUrl);
        });
    });
};

const inProgressAttr = 'inProgress'
const inProgressValue = 'true';

const inProgress = (button) => button.dataset[inProgressAttr] === inProgressValue;
const setInProgress = (button) => button.dataset[inProgressAttr] = inProgressValue;